import { Extension } from '@tiptap/core'

export interface EnterToSendOptions {
  onSend: () => void
  onCancel: () => void
}

export const EnterToSend = Extension.create<EnterToSendOptions>({
  name: 'enterToSend',

  addOptions() {
    return {
      onSend: () => {},
      onCancel: () => {},
    }
  },

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        this.options.onSend()
        return true
      },
      'Shift-Enter': () => {
        return this.editor.commands.setHardBreak()
      },
      Escape: () => {
        this.options.onCancel()
        return true
      },
    }
  },
})
